export const tabNameList = {
  commonImage: 'commonImage',
  assetImage: 'assetImage',
  // 音效库
  commonAudio: 'commonAudio',
  // 背景音乐
  commonBgm: 'commonBgm',
  assetAudio: 'assetAudio',

  assetVideo: 'assetVideo',
  commonVideo: 'commonVideo',
  // 序列帧
  commonFrameSequence: 'commonFrameSequence',
  assetFrameSequence: 'assetFrameSequence',

  // 模型
  commonModel: 'commonModel',
  assetModel: 'assetModel',

  // 动作
  commonAction: 'commonAction',
}

export interface currentTabConfig {
  key: string
  tagId: string | null
  groupId: string | null
  searchValue: string
  search: string
  componentsTitle: string
  type: number | null
  listTagId: string | null
}

/** 接口查询条件 */
/**
 如果要设定默认查询条件，在组件中传入:model="query"
 query = {
  type: 'image',  // 图片-image,音频-audio,video-视频
  formats: ['png']
  size_max: 0
  size_min: 0
  order: '-updated_time'
 }
  */
export interface modelConfig {
  type: string
  formats?: string[]
  size_max?: number
  size_min?: number
  order?: string
  frames?: number // 序列帧-帧图片数量
  skeleton_type?: number // 模型-骨骼类型
}
